import { Modal } from './Modal'

export function PipelineActionModal() {
  return (
    <>
      <Modal />
    </>
  )
}
